"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_rewards__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "8b7d0f3d-a86c-4395-9a91-d61c4c3fd40f",
    "data-name": "Rewards_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "553f3a9c-625c-402f-b0d1-a76f20a21b41",
    x1: 72,
    y1: 4,
    x2: 120,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "729fda83-f096-482d-b8a3-2b759fef507d",
    x1: 77.5,
    y1: 20.5,
    x2: 114.5,
    y2: 57.5,
    xlinkHref: "#553f3a9c-625c-402f-b0d1-a76f20a21b41"
  })), /*#__PURE__*/React.createElement("title", null, "rewards-hi-dark"), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 69.99,
    width: 52,
    height: 8,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#4a4d4e",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,78H74a6,6,0,0,1-5.91-5A6,6,0,0,0,74,80h44a6,6,0,0,0,5.91-7A6,6,0,0,1,118,78Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 16,
    width: 72,
    height: 24,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 16,
    width: 72,
    height: 24,
    opacity: 0.2,
    fill: "url(#553f3a9c-625c-402f-b0d1-a76f20a21b41)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 38,
    width: 72,
    height: 2,
    opacity: 0.2,
    fill: "url(#729fda83-f096-482d-b8a3-2b759fef507d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.07,40.61l23.58-23.44a4,4,0,0,1,5.66,0L150.23,33a6,6,0,0,1,0,8.48L122,69.66A8,8,0,0,1,116.38,72H76.52a1.17,1.17,0,0,1-.83-2Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.07,40.61l23.58-23.44a4,4,0,0,1,5.66,0L150.23,33a6,6,0,0,1,0,8.48L122,69.66A8,8,0,0,1,116.38,72H76.52a1.17,1.17,0,0,1-.83-2Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.38,70A8,8,0,0,0,122,67.66l28.2-28.22a6,6,0,0,0,1.66-3.24,6,6,0,0,1-1.66,5.24L122,69.66A8,8,0,0,1,116.38,72H76.52a1.17,1.17,0,0,1-.83-2h40.69Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.72,40.61,63.14,17.17a4,4,0,0,0-5.66,0L41.76,33a6,6,0,0,0,0,8.48l28,28.22A8,8,0,0,0,75.41,72H116.9a.49.49,0,0,0,.35-.84Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.41,70a8,8,0,0,1-5.66-2.34l-28-28.22A6,6,0,0,1,40.1,36.2a6,6,0,0,0,1.66,5.24l28,28.22A8,8,0,0,0,75.41,72H116.9a.49.49,0,0,0,.35-.84L116.09,70Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,74.06h24a4,4,0,0,1,4,4v5.75a0,0,0,0,1,0,0H80a0,0,0,0,1,0,0V78.06A4,4,0,0,1,84,74.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.05,74h23.9A4.05,4.05,0,0,1,112,78.05V84a0,0,0,0,1,0,0H80a0,0,0,0,1,0,0V78.05A4.05,4.05,0,0,1,84.05,74Z",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 128,
    r: 39.11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,80a48,48,0,1,0,48,48A48,48,0,0,0,96,80Zm0,87.11A39.11,39.11,0,1,1,135.11,128,39.11,39.11,0,0,1,96,167.11Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,80a48,48,0,1,0,48,48A48,48,0,0,0,96,80Zm0,87.11A39.11,39.11,0,1,1,135.11,128,39.11,39.11,0,0,1,96,167.11Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,88.89A39.11,39.11,0,1,0,135.11,128,39.11,39.11,0,0,0,96,88.89Zm19.13,49.62a20.49,20.49,0,0,1-5.59,6.79A21,21,0,0,1,90.65,149a22.34,22.34,0,0,1-12.48-9.34,23.85,23.85,0,0,1-2.84-6.3c0-.17-.1-.34-.14-.51a25.9,25.9,0,0,1-.72-3.87,27.4,27.4,0,0,1-.13-4c0-.14,0-.27,0-.41a30.82,30.82,0,0,1,.84-5.62,33.92,33.92,0,0,1,11-17.53,36.64,36.64,0,0,1,10.72-6.28c1.09-.42,2.16-.78,3.2-1.09.68-.2,1.35-.38,2-.54a39.63,39.63,0,0,1,5-.89,19.9,19.9,0,0,1,4.93,0,4.4,4.4,0,0,1,.79.19,16.12,16.12,0,0,0-12.75,15.68c0,.17,0,.37,0,.52a25.74,25.74,0,0,1,8.27,3.19,18.65,18.65,0,0,1,5.43,5l.32.46a18.5,18.5,0,0,1,2.36,5,22.41,22.41,0,0,1,.91,5.67c0,.26,0,.51,0,.76A21,21,0,0,1,115.13,138.5Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,88.89A39.11,39.11,0,1,0,135.11,128,39.11,39.11,0,0,0,96,88.89Zm19.13,49.62a20.49,20.49,0,0,1-5.59,6.79A21,21,0,0,1,90.65,149a22.34,22.34,0,0,1-12.48-9.34,23.85,23.85,0,0,1-2.84-6.3c0-.17-.1-.34-.14-.51a25.9,25.9,0,0,1-.72-3.87,27.4,27.4,0,0,1-.13-4c0-.14,0-.27,0-.41a30.82,30.82,0,0,1,.84-5.62,33.92,33.92,0,0,1,11-17.53,36.64,36.64,0,0,1,10.72-6.28c1.09-.42,2.16-.78,3.2-1.09.68-.2,1.35-.38,2-.54a39.63,39.63,0,0,1,5-.89,19.9,19.9,0,0,1,4.93,0,4.4,4.4,0,0,1,.79.19,16.12,16.12,0,0,0-12.75,15.68c0,.17,0,.37,0,.52a25.74,25.74,0,0,1,8.27,3.19,18.65,18.65,0,0,1,5.43,5l.32.46a18.5,18.5,0,0,1,2.36,5,22.41,22.41,0,0,1,.91,5.67c0,.26,0,.51,0,.76A21,21,0,0,1,115.13,138.5Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174a48,48,0,0,1-48-47c0,.33,0,.66,0,1a48,48,0,1,0,96,0c0-.34,0-.67,0-1A48,48,0,0,1,96,174Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }));
}

var _default = ic_rewards__dark;
exports.default = _default;